export function Spinner({ size = 24 }: { size?: number }) {
  return (
    <div className="flex items-center justify-center p-6">
      <div
        className="animate-spin rounded-full border-2 border-hint border-t-transparent"
        style={{ width: size, height: size }}
      />
    </div>
  );
}

export function CenteredError({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 p-6 text-center">
      <div className="text-2xl">😬</div>
      <div className="text-sm text-hint">{message}</div>
    </div>
  );
}
